function Footer() {
  return (
    <p className="footer">&hearts; Jessica Strawford and Maggie Devine Designs Collaboration &hearts;</p>
  )
}

export default Footer